import React, { useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import * as ServicesService from "../../../services/services.services";
import * as Yup from "yup";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const ServiceEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation();

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Services"), url: "/admin/cms/services/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    ServicesService.Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.image);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required(t("label_title_error"))
      .max(50, t("Max allowed length of characters is 50"))
      .test("no-spaces", t("label_title_error"), (value) => value.trim()),
    service_type: Yup.string().required(t("Service Type is required")),
    files: Yup.mixed()
      .required(t("label_image_error"))
      .test("fileType", t("label_image_format_error"), (value) => {
        if (!value) return false;
        if (value.type) {
          const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
          return supportedFormats.includes(value.type);
        } else {
          return true;
        }
      }),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={{
            title: showdefault && showdefault.title ? showdefault.title : "",
            slug: showdefault && showdefault.slug ? showdefault.slug : "",
            files: showdefault && showdefault.image ? showdefault.image : "",
            service_type:
              showdefault && showdefault.service_type
                ? showdefault.service_type
                : "remedies",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", params.id);
            formData.append("title", values.title);
            formData.append("service_type", values.service_type);
            formData.append("image", values.files);
            ServicesService.Edit(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  if (saveType !== "Save") {
                    setTimeout(() => {
                      navigate(`/admin/cms/services/list/${params.pgno}`);
                    }, 1000);
                  }
                  globalLoader(false);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                }
                globalLoader(false);
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              {console.log("errors", errors)}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">
                          Edit Service
                        </h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("Title")}:{" "}
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name="title" />
                          </span>
                        </div>
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="slug" className="text-left d-flex">
                            {t("Slug")}:{" "}
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="slug"
                            id="slug"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.slug}
                            disabled
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="service_type"
                            className="text-left d-flex"
                          >
                            {t("Service Type")}:{" "}
                            <span className="requirestar">*</span>
                          </label>

                          <select
                            name="service_type"
                            id="service_type"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.service_type}
                            className="form-control"
                            disabled
                          >
                            <option value="">Select Service Type</option>
                            <option value="remedies">Remedies</option>
                            <option value="services">Services</option>
                          </select>

                          <span className="text-danger d-flex text-left">
                            <ErrorMessage name="service_type" />
                          </span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="files" className="text-left d-flex">
                            {t("label_image")}:
                            <span className="requirestar">*</span>
                            {/* <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Recommended Size (1920x887)</Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper> */}
                          </label>
                          <input
                            className="form-control imgInput"
                            id="files"
                            name="files"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue(
                                "files",
                                event.currentTarget.files[0] || "",
                              );
                              event.currentTarget.files.length === 1
                                ? setPreviewImage(
                                    URL.createObjectURL(
                                      event.currentTarget.files[0],
                                    ),
                                  )
                                : setPreviewImage("");
                            }}
                          />
                          <span
                            className="text-danger d-flex text-left"
                            id="errortext"
                          >
                            {errors.files && touched.files && errors.files}
                          </span>
                        </div>
                        {previewimage ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img
                                src={previewimage}
                                style={{ height: "100px" }}
                                alt={"img"}
                              />
                              <div className="img_options">
                                <button
                                  type="button"
                                  className="text-danger"
                                  onClick={() => {
                                    setPreviewImage("");
                                    setFieldValue("image", null);
                                    document.getElementById("files").value = "";
                                  }}
                                >
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}

                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default ServiceEdit;
